export const FETCH_USER_LIST_DATA = "FETCH_USER_LIST_DATA";
